module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Select"}}')
  delete Component.options._Ctor
}
